export enum BankIdVerifiedByEnum {
    bankid = 'bankid',
    courier = 'courier',
}
